export function getEntityShortcode (context, orgId) {
  // console.log('getEntityShortcode', context, orgId)
  const targetAccountOrg = context.entities.find(function (one) {
    return one.id === orgId
  })
  const targetEntity = targetAccountOrg?._xeroOrganisation
  const shortCode = targetEntity?.details?.shortCode

  return shortCode
}
